import OnboardingLayoutPrimeContainer from "./OnboardingLayoutPrimeContainer";
import OnboardingLayoutPrimeStore from "./OnboardingLayoutPrimeStore";

export default OnboardingLayoutPrimeStore(OnboardingLayoutPrimeContainer);
